module.exports = __webpack_public_path__ + "static/media/X.a17ce910.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/X.jpg
// module id = 92
// module chunks = 0